import React from 'react'
import Text from 'react-text'
import Griddle, {RowDefinition, ColumnDefinition} from 'griddle-react'
import {Context, Consumer} from '../../../../context'
import {bind} from 'helpers/utils'
import {faUsers, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import ContextLoader from '../../../context-loader'
import {Pagination, PageDropdown} from '../../../pagination'
import components from './columns'

import './table.styl'

const {columns, headers} = components

function Filter (props) {
  return (<Consumer>{ context => {
    const group = context.groups.find(({id}) => id == context.groupId)
    const student = context.students[context.studentId]
    return (
      <div className="info">
        {group && (
          <div className="group-name">
            <div className="icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="name-wrapper">
              <div className="name">
                {group.name}
              </div>
            </div>
          </div>
        )}
        {student && (
          <div className="student-name">
            <div className="icon">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className="name">
              {student.name}
            </div>
          </div>
        )}
      </div>
    )}}</Consumer>)
}

function NoResults (props) {
  return (
    <div className={props.className}>
      <Text id="catalog_search_no_results_label" />
    </div>
  )
}


const Layout = ({Table, Pagination, Filter}) => (
  <div className="download-log-table">
    <div className="head">
      <Filter />
      <div style={{flexGrow: 1}} />
      <Pagination />
    </div>
    <Table />
  </div>
)

export default class Student extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
    bind(this, 'goPage', 'goNext', 'goPrevious', 'sort')
  }

  goPage (page) {
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{page}})
  }

  goNext () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage + 1)
  }

  goPrevious () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage - 1)
  }

  sort ({id, sortAscending}) {
    const orderBy = `${sortAscending ? '' : '-'}${id}`
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{orderBy}})
  }

  render () {
    const context = this.context 
    const [pageProperties, ...log] = context.downloadLog
    const groups = context.downloadLogFilters.reduce((gs,g) => {
      gs[g.id] = g
      return gs
    }, {})
    const downloadLog = log.map(o => ({
      ...o,
      group: groups[o.group],
      lesson: context.lessonLogTitles[o.title]
    }))
    return (
      <ContextLoader id="downloadLog" className="download-log">
        <div className="download-log-results">
          <Griddle
            data={downloadLog}
            components={{
              NoResults,
              PageDropdown,
              Pagination,
              Layout,
              Filter
            }}
            pageProperties={pageProperties}
            events={{
              onNext: this.goNext,
              onPrevious: this.goPrevious,
              onGetPage: this.goPage,
              onSort: this.sort
            }}
          >
           <RowDefinition>
             <ColumnDefinition
               id='groupName'
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.GroupColumn}
             />
             <ColumnDefinition
               id='title'
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.LessonColumn}
             />
             <ColumnDefinition
               id='start'
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.StartColumn}
             />
             <ColumnDefinition
               id='firstDownload'
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.FirstDownloadColumn}
             />
             <ColumnDefinition
               id="onlineViews"
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.OnlineViewsColumn}
             />
             <ColumnDefinition
               id='downloadCount'
               customHeadingComponent={headers.DownloadLogHeader}
               customComponent={columns.DownloadCountColumn}
             />
             <ColumnDefinition
               id='links'
               customHeadingComponent={headers.EmptyHeader}
               customComponent={columns.DownloadLinksColumn}
             />
           </RowDefinition>
          </Griddle>
        </div>
    </ContextLoader>)
  }
}
